import React, { useState } from 'react';
import Cookies from 'js-cookie';
import Firebase from '../auth/firebase';
import axios from 'axios';
import useDataApi from '@isomorphic/shared/Library/hooks/useDataApi';
import { Button, notification } from 'antd';
export const AuthContext = React.createContext();

const fakeUserData = {
  id: 1,
  name: 'Jhon Doe',
  avatar: '',
  roles: ['USER', 'ADMIN'],
};

const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
    placement: 'bottomLeft'
  });
};
/**
 * We have used Fake JWT token from "jwt.io"
 * This is a sample token to show auth is working
 * Your token will come from your server when user successfully loggedIn.
 */

const fakeToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJuYW1lIjoidGFyZXEgam9iYXllcmUiLCJyb2xlcyI6ImFkbWluIn0.k74_B-zeWket405dIAt018mnQFMh_6_BTFpjB77HtRQ';

const addItem = (key, value = '') => {
  /**
   *  Using the local storage code....
   */
  //if (key) localStorage.setItem(key, value);

  /**
   *  Using the Cookies code...
   */
  if (key) Cookies.set(key, value, { expires: 7 });
};

const clearItem = key => {
  /**
   *  Using the local storage code....
   */
  // localStorage.removeItem(key);

  /**
   *  Using the Cookies code...
   */
  Cookies.remove(key);
};

const isValidToken = (user) => {
  /**
   *  Using the local storage code....
   */
  // const token = localStorage.getItem('id_token');

  /**
   *  Using the Cookies code...
   */

  let  token;
  if (user){
  token= Cookies.get('id_token');
  }
  // JWT decode & check token validity & expiration.
  if (token) return true;
  return false;
};

const isAuthenticated = (user) => {

  if (isValidToken(user)) return true;
  return false;
}

const AuthProvider = props => {
  const [loggedIn, setLoggedIn] = useState(isValidToken(user));
  const [authenticated, setAuthenticated] = useState(loggedIn);
  // const [loggedOut, setLoggedOut] = useState(true);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [profile, setProfile] = useState(null);

  const signIn = async (params) => {
    /**
     * Make post request here to authenticate with fetch
     * if returns true then change the state
     */
    let data;
    const email = params.email;
    const password = params.password
    data = await Firebase.login(Firebase.EMAIL, {
      email,
      password,
    });
    //window.mt('send', 'pageview', {email: email});
   // window.mt('send', 'pageview', {email: 'mustaphab@outlook.com',firstname: 'Mustapha', tags: 'espacemembre'}, {onload: function() { alert("Tracking request is loaded"); }});
    window.mt('send', 'pageview', {email: email, tags: 'membre'});
    const user = data && data.user ? data.user : false;
    const message =
      user === false && data && data.message
        ? openNotificationWithIcon('error', data.message)
        :  'Sorry Some error occurs';
    if (user) {
      const token = await user.getIdToken();
      let url = 'https://us-central1-ziaway-dev.cloudfunctions.net/api/getUser/';

      url += user.uid;
  
      let  header = {
        'authorization': 'Bearer ' + token,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    }
      const person = await axios.get(url,{headers:header}).then(res => {
   
        setProfile(res.data);
        
        // window.alert(JSON.stringify(res.data.payload[0].tables.value.numberValue, null, 2));

        setToken(token);
        setUser(user);
        addItem('id_token', token);
        setLoggedIn(true);
        //setEstimation(res.data.payload[0].tables.value.numberValue);
        return res;
      });
      
    
    



    } else {
      //notification('error', message);

    }

 
    /*  setUser(fakeUserData);
      setToken(fakeToken);
      addItem('token', fakeToken);
      setLoggedIn(true); */
  };
  const signUp = async (params) => {
    //console.log(params, 'sign up form Props');

    let data;
    const email = params.email;
    const password = params.password
    const profile = {
      username: params.username + ' ' + params.prenom,
      nom: params.username,
      prenom: params.prenom,
      email: params.email,
      plan: 'Plan découverte'

    }
    data = await Firebase.signup(Firebase.EMAIL, {
      email,
      password,
    });

    const user = data && data.user ? data.user : false;
    const message =
      user === false && data && data.message
        ? openNotificationWithIcon('error', data.message)
        : 'Sorry Some error occurs';
    if (user) {
      // const updatedUser =  Firebase.updateProfile(email,params.username);
      const token = await user.getIdToken();
      const uId = user.uid;
      const header = {
        'authorization': 'Bearer ' + token,
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
    }
      axios.post(`https://us-central1-ziaway-dev.cloudfunctions.net/api/addUsers`, { uId, profile },{ headers: header }, { crossdomain: true })
        .then(res => {
        
          // window.alert(JSON.stringify(res.data.payload[0].tables.value.numberValue, null, 2));
          setToken(token);
          setUser(user);
          addItem('id_token', token);
          setLoggedIn(true);
          window.mt('send', 'pageview', {email: params.email,firstname:params.prenom,lastname:params.username, tags: 'membre , plan découverte'});
          //setEstimation(res.data.payload[0].tables.value.numberValue);
          return res;
        });

    } else {
      //notification('error', message);

    }
    return message
  };

  /**
   * For 3rd-party Authentication [e.g. Autho0, firebase, AWS etc]
   *
   */
  const tokenAuth = (token, user = {}) => {
    setUser(user);
    setToken(token);
    addItem('id_token', token);
    setLoggedIn(true);
  };

  const forgetPass =async(params) => {
 
    let data;
    try {
      data = await Firebase.resetPassword(params);
      openNotificationWithIcon('success',"Veuillez suivre la procédure envoyée à votre adresse Email.")

    } catch (error) {
   
      openNotificationWithIcon('error',error.message);
    }
  
  };



  const changePass = params => {
    
  };

  const logOut = () => {
    setUser(null);
    setToken(null);
    clearItem('id_token');
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        loggedIn,
        logOut,
        signIn,
        signUp,
        forgetPass,
        changePass,
        tokenAuth,
        authenticated,
        user,
        profile,
        token,
      }}
    >
      <>{props.children}</>
    </AuthContext.Provider>
  );
};

export default AuthProvider;
